import React, { useEffect, useCallback, useState } from 'react';
import { Redirect } from 'react-router-dom';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel, Tabs, Tab,
	FormControl, FormGroup
} from '@material-ui/core';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer, FilesDropzone, Alert, FilePicker } from 'components';
import { enqueueSnackbar } from 'actions';
import { SetFormState } from '../../../actions/AlgorithmsActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	paper: {
		padding: theme.spacing(1),
	},
	popover: {
		pointerEvents: 'none',
	},
}));

const ByFile = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.algorithmsReducer.formState);

	const _onChangeInput = (event) => {
		if (event.target.files && event.target.files.length > 0) {
			const file = event.target.files[0];
			setFormState({
				...formState,
				values: {
					...formState.values,
					algoInputFilePath: file
				}
			});
		}
	};

	return (
		<div className={classes.fields}>
			{/* New row */}
			<Grid container spacing={3}>
				<Grid item md={6} xs={6}>
					<FilePicker
						placeholder="Please select a file with a list of Sites"
						accept=".xlsx"
						onChange={_onChangeInput}
						value={formState.values.algoInputFilePath?.name || ''}
					/>
				</Grid>
			</Grid>
		</div>
	);
};

export default ByFile;
